import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { compose } from 'recompose';
import { Table } from 'react-bootstrap';
import { queryGetTicketNumberGroupGQL } from './graphql/getTicketNumberGroupApi';

const propTypes = exact({
  summary: PropTypes.object.isRequired,
});


const TicketNumberGroup = (props) => {
  const { summary } = props;
  const { totalManHours, totalNumberTickets, districtTicketNumberGroup } = summary;
  return (
    <Table condensed>
      <thead>
        <tr>
          <th>District</th>
          <th>Number of Tickets</th>
          <th>Man Hours</th>
        </tr>
      </thead>
      <tbody>
        {districtTicketNumberGroup.map((dtng) => {
          return (
            <tr key={dtng.district.name}>
              <td>{dtng.district.name}</td>
              <td>{dtng.totalNumberTickets}</td>
              <td>{dtng.totalManHours.to_string}</td>
            </tr>
          );
        })}
      </tbody>
      <tfoot>
        <tr>
          <th>Totals</th>
          <td><strong>{totalNumberTickets}</strong></td>
          <td><strong>{totalManHours.to_string}</strong></td>
        </tr>
      </tfoot>
    </Table>
  );
};

TicketNumberGroup.propTypes = propTypes;

const enhance = compose(queryGetTicketNumberGroupGQL);

export default enhance(TicketNumberGroup);
